import { STATUS_COLOR, TIER_KEY } from '../constants.js';

/** Legend explaining the status tiers (and the % bands behind them). */
export function StatusKey() {
  return (
    <ul className="key" aria-label="Status key">
      {TIER_KEY.map((t) => (
        <li className="key__item" key={t.status}>
          <span className="key__dot" style={{ background: STATUS_COLOR[t.status] }} aria-hidden="true" />
          <span>
            <span className="key__label">{t.label}</span> — {t.detail}
          </span>
        </li>
      ))}
    </ul>
  );
}
